// @ts-nocheck
/* eslint-disable */


import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BehaviorSubject, map, Observable, switchMap, take, tap} from 'rxjs';
import {City} from '../../cities/cities.types';


@Injectable({
    providedIn: 'root'
})
export class CreditService {
    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient) {
    }

    private _credit: BehaviorSubject<number | null> = new BehaviorSubject(null);
    public credit$: Observable<number> = this._credit.asObservable();

    updateCredit(credit):void {
        this._credit.next(credit);
    }

    public updatePaymentMethod(data: any): Observable<any> {
        const id = {idPaymentMethod: data};
        return this._httpClient.put('api/stripe/payment-method', id);
    }

    public getPaymentMethod(): Observable<any> {
        return this._httpClient.get('api/stripe/payment-method');
    }

    public createIntent(): Observable<any> {
        return this._httpClient.get('api/stripe/setup-intent');
    }

    public chargePayment(paymentId : number): Observable<any> {
        return this._httpClient.post('api/gopay/charge-payment', {paymentId : paymentId , returnUrl: 'https://lovlio.techcrowd.space/credit-success'});
    }

    public getBalance(): Observable<any> {
        return this._httpClient.get('api/gopay/transaction');
    }



}
